// Placeholder component for module replacement, nothing will be shown unless module replaced from brand app.
export function HotelBasketContentRegion() {
    return null;
}
